import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useUserContext } from '@/contexts/UserContext';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const BOAdminPrivateRoute = () => {
	const { user } = useUserContext(); // Adjust based on how you handle user authentication
	const role = JSON.parse(localStorage.getItem('role'));
    const navigate = useNavigate();

	useEffect(() => {
		if (!user || (role && !['super-admin', 'admin', 'manager'].includes(role))) {
			toast.info("Zone réservée aux administrateurs", {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

            navigate('/');
		}
	}, []);

	return user ? <Outlet /> : <Navigate to="/" />;
};

export default BOAdminPrivateRoute;
